import ApplicationsStatusFilter from './options/status'
import ApplicationsTextFilter from './options/text'
import ApplicationsTypeFilter from './options/type'

import './styles.scss'

export default function ApplicationsFilters() {
  return (
    <div className={`applications-filters`}>
      <ApplicationsTextFilter />
      <ApplicationsStatusFilter />
      <ApplicationsTypeFilter />
    </div>
  )
}
